import type { DynamicEventData } from '@/types';

// id can be a numeric event ID (regular events) or a 96-character eventcode string (closed events)
export async function fetchDynamicEvent(id: number | string): Promise<DynamicEventData> {
  const params = new URLSearchParams({
    id: id.toString()
  });
  let urlParams = '';
  
  urlParams = '?' + params.toString();

  try {
    const response = await fetch('/of2/json/event_dynamic_data'+urlParams, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    const data = await response.json();
    if (data) {
        console.log("Fetched dynamic event data:", data);
      return data;
    } else {
      throw new Error('Invalid event format');
    }
  } 
  catch (e) {
    console.error("Failed to fetch dynamic event:", e);

    return {} as DynamicEventData; // Fallback empty event
  }
}


